import React, {useEffect, useState} from "react";
import {FileUploader} from "../components/FileUploader";
import {db, storage} from "../firebase_setup/firebase";
import Select, {SingleValue} from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {User,getAuth,onAuthStateChanged,signInWithEmailAndPassword, signOut} from "firebase/auth";
import "../App.css"
import './Admin.css'
import {collection, doc, getDocs, updateDoc,} from 'firebase/firestore'


function Admin() {

    const festivalNames: string[] = [`Dashera`, `Diwali`, `Diwali Poojan`, `Fuldolotsav`, `Ganesh Chaturthi`,
        `Gurupoornima`, `Hari Jayanti`, `Hindola`, `Janmashtami`, `JalJirni Ekadashi`, `Maha Shivratri`,
        `New Year Annakut`, `Normal Sabha` , `Patotsav`, `Rathyatra`, `Shakotsav`, `Sharad Poonam`, `Shikshapatri Jayanti`,
        `Uttarayan`, `Vachanamrut Jayanti`];

    const options = festivalNames.map(name => ({label: name, value: name}));

    const defaultOption = options[12];

    const [festivalName, setFestivalName] = useState(defaultOption.value);

    // State to store uploaded files
    const [files, setFiles] = useState<FileList>();

    const [userEmail, setUserEmail] = useState("");

    const [userPassword, setUserPassword] = useState("");

    const [folders,setFolders] = useState<{name : string, prevValue : boolean }[]>([]);

    const [foldersLoaded, setFoldersLoaded] = useState(false);

    const [user, setUser] = useState<User | null>(null);

    const fetchData = async ()  => {
        setFoldersLoaded(false);
        setFolders([]);
        const subCollection = collection(db,'Festivals');
        const querySnapshot = await getDocs(subCollection);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());
            setFolders(previousState => [...previousState, {name: doc.id, prevValue: doc.data()['active']}])
        });
        setFoldersLoaded(true)
    }

    useEffect(() => {
        let ignore = false;
        const effectFetchData = async ()  => {
            const subCollection = collection(db,'Festivals');
            const querySnapshot = await getDocs(subCollection);
            if (!ignore) {
                querySnapshot.forEach((doc) => {
                    console.log(doc.id, " => ", doc.data());
                    setFolders(previousState => [...previousState, {name: doc.id, prevValue: doc.data()['active']}])
                });
            }
        }
        effectFetchData().then(() => {setFoldersLoaded(true);})
        return () => {
            ignore = true;
        }
    }, []);
    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, firebaseUser => {
            if (firebaseUser) {
                // User is signed in
                setUser(firebaseUser);
            } else {
                // User is signed out
                setUser(null);
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);
    function handleEmailChange(event : React.ChangeEvent<HTMLInputElement>) {
        setUserEmail(event.target.value)
    }
    function handlePasswordChange(event : React.ChangeEvent<HTMLInputElement>) {
        setUserPassword(event.target.value)
    }

    function handleLogIn() {
        const auth = getAuth();
        signInWithEmailAndPassword(auth, userEmail, userPassword)
            .then((user) => {
                console.log(user)
                // Signed in
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(`${errorCode}:${errorMessage}`)
            });
    }

    function logOut() {
        const auth = getAuth();
        signOut(auth).then(() => {
            console.log("logged out")
        });
    }

    // Handle file upload event and update state
    function handleMultipleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.files !== null){
            setFiles(event.target.files);
        }
    }

    const changeFestival = (festival: SingleValue<{label : string, value : string}>) => {
        if (festival != null){
            setFestivalName(festival.value);
        }
    }

    function changeSelectedFolder(event: React.ChangeEvent<HTMLInputElement>) {
        console.log(event.target.id, " is ", event.target.checked)
        console.log(folders)
        const fireStoreRef = doc(db,'Festivals',event.target.id);
        updateDoc(fireStoreRef,{active : event.target.checked}).then(
            () => {
                console.log(event.target.id, " changed to ", event.target.checked)
            })
    }

    const selectStyle = {
        control: (provided : any) => ({
            ...provided,
            width: 400,
        }),
    }

    return (
        <>
        {user !== null? (
            <div className="center-align">
                <div className="flex-end">
                    <Button className="btn-danger" variant="danger" onClick={logOut}>
                        Log out
                    </Button>
                </div>
                <p>
                    Hi, {user.email?.split('@')[0]}
                </p>
                <div className="center-flex">
                    <form>
                        <label>
                            Select an event for the pictures:
                        </label>
                        <Select options={options} defaultValue={defaultOption} onChange={changeFestival}
                                styles={selectStyle}/>
                    </form>
                </div>
                <div className="center-flex">
                    <Form.Group controlId="formFileMultiple" className="mb-3" style={{width: '400px'}}>
                        <Form.Label>Select Pictures to Upload:</Form.Label>
                        <Form.Control type="file" multiple accept="image/*" onChange={handleMultipleFileChange}/>
                    </Form.Group>
                </div>
                <FileUploader storage={storage} files={files} festivalName={festivalName} fetchData={fetchData}/>
                <p>Images on Display:</p>
                <div className="center-flex">
                    {foldersLoaded ? (
                            <Form className="centered-form">
                                {folders.map((folder) => (
                                    <Form.Switch className="fitted-switch"
                                                 inline={false}
                                                 key={folder.name}
                                                 id={folder.name}
                                                 label={folder.name.replace(/-/, ' ')}
                                                 onChange={changeSelectedFolder}
                                                 defaultChecked={folder.prevValue}
                                    />
                                ))}
                            </Form>
                        ) :
                        <p>Loading...</p>
                    }
                </div>
            </div>
        ) : (
            <div className="grid-display">
                <Form style={{width: '300px', margin: 'auto'}}>
                    <Form.Group className="mb-3" controlId="formBasicEmail" style={{justifyContent: 'center'}}>
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" onChange={handleEmailChange}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="Password" onChange={handlePasswordChange}/>
                    </Form.Group>

                    <Button variant="primary" onClick={handleLogIn}>
                        Log In
                    </Button>
                </Form>
            </div>
        )}
        </>
    )
}

export default Admin;